// extracted by mini-css-extract-plugin
export default {"outer":"loader_outer__t9dua","middle":"loader_middle__Jr5Ws","rotation":"loader_rotation__HqSsN","inner":"loader_inner__oyNAQ"};